/* globals jQuery, Namespace */
/**
 * Maps request form extended to gets validator and elements ready to be sent to the server.
 *
 * @file front/common/request/extended_form.js
 */
(function (ns, $) {
    'use strict';

    /**
     * Request Extended Form object constructor.
     *
     * @param {Node} form
     * @constructor
     */
    function RequestExtendedForm(form) {
        this.formElements = [];
        this.extendedRules = {};
        this.containerElement = {};
        this.form = form;
    }

    /**
     * Maps elements within form extended container.
     */
    function mapElements(form) {
        var self = this;

        // Init fields.
        this.formElements = [];
        this.extendedRules = {};
        this.containerElement = $(form).find('.jq_fe_container');

        this.containerElement.each(function (index, element) {
            var $element = $(element),
                $elementId = $element.find('.jq_fe_id'),
                $elementValue = $element.find('.jq_fe_value'),
                $elementLabel = $element.find('.jq_fe_label'),
                $elementType = $element.find('[class*="jq_fe_type_"]'),
                classType;

            if ($elementId.length === 0 ||
                    $elementLabel.length === 0 ||
                    $elementValue.length === 0 ||
                    $elementType.length === 0) {
                return false;
            }

            // Gets element type from a class in the element.
            classType = $elementType.attr('class').match(/.*jq_fe_type_(\w+).*/);

            self.extendedRules[$elementValue.attr('name')] = {};
            if ($element.hasClass('required')) {
                $.extend(self.extendedRules[$elementValue.attr('name')], {required: true});
            }

            switch (classType[1]) {
                case 'text_numeric':
                    $.extend(self.extendedRules[$elementValue.attr('name')], {number: true});
                    break;
            }

            // Special case for grouped inputs.
            if ($elementId.length > 1 || $elementValue.length > 1) {
                if ($elementId.length !== $elementValue.length) {
                    return false;
                }

                if (!$elementValue.data('datepicker')) {
                    // Supose that element is a group of checkboxes or radios.
                    $elementId = $element.find('.jq_fe_id:checked');
                    $elementValue = $element.find('.jq_fe_value:checked');
                }
            }

            $elementId.each(function (index) {
                var label = $elementLabel[index] || $elementLabel[0];
                self.formElements.push({
                    id: $elementId[index].id,
                    type: classType[1],
                    field: $(label).text(),
                    value: $elementValue[index].value
                });
            });
        });
    }

    /**
     * Gets elements ready to be sent to the server.
     */
    RequestExtendedForm.prototype.getElements = function getElements() {
        mapElements.call(this, this.form);
        return this.formElements;
    };

    /**
     * Gets extended rules for jQuery.validator.
     */
    RequestExtendedForm.prototype.getValidator = function getValidator() {
        mapElements.call(this, this.form);
        return this.extendedRules;
    };

    ns.request = ns.request || {};
    ns.request.ExtendedForm = RequestExtendedForm;

}(Namespace, jQuery));
